<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>线索列表</h4>
        </div>
        <div class="main-bd mg20">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="item in active_list" :key="item.value" :label="item.label + '（' + (active_count.hasOwnProperty(item.type) ? active_count[item.type] : 0) + '）'" :name="item.value"></el-tab-pane>
            </el-tabs>
            <el-row class="searchSection">
                <el-form ref="filterModel" :inline="true" :model="filterModel">
                    <el-form-item label="线索ID">
                        <el-input size="small" v-model="filterModel.id" placeholder="请输入线索ID"></el-input>
                    </el-form-item>
                    <el-form-item label="申请人" prop="contact_name">
                        <ContactClueSelect ref="ContactClueSelect" v-model="filterModel.contact_name"
                                        @change="ContactClueHandleChange"></ContactClueSelect>
                    </el-form-item>
                    <el-form-item label="申请人电话" >
                        <el-input size="small" v-model="filterModel.mobile" placeholder="请输入电话"></el-input>
                    </el-form-item>
                    <el-form-item label="所在单位">
                        <AdressClueSelect ref="AdressClueSelect" v-model="filterModel.customer_name"
                                        @change="AdressClueHandleChange"></AdressClueSelect>
                    </el-form-item>
                    <span v-show="isCollapse">
                        <el-form-item label="产品类型" prop="product_id">
                            <el-select v-model="filterModel.product_id" size="small">
                                <el-option :value="product.id" v-for="(product,index) in productList" :key="index"
                                        :label="product.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <DistrictLinkage ref="DistrictLinkage" :provinceId="filterModel.province_id"
                                        :cityId="filterModel.city_id" :districtId="filterModel.district_id"
                                        @change="handleChange"></DistrictLinkage>
                        <el-form-item label="申请时间">
                            <el-date-picker
                                size="small"
                                v-model="filterModel.apply_time"
                                type="daterange"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="起始日期" prop="start_time">
                            <el-date-picker
                                    size="small"
                                    v-model="filterModel.start_time"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择起始日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="截止日期" prop="end_time">
                            <el-date-picker
                                    size="small"
                                    v-model="filterModel.end_time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择截止日期">
                            </el-date-picker>
                        </el-form-item> -->
                        <el-form-item label="来源" prop="source">
                            <ChannelCascader ref="ChannelCascader" :channel="channel" @change="channelHandleChange"></ChannelCascader>
                        </el-form-item>
                        <el-form-item label="申请人真实性">
                            <ClueStatus ref="ClueStatus" v-model="filterModel.status" @change="statusHandleChange" key="1"></ClueStatus>
                        </el-form-item>
                        <el-form-item label="负责人真实性">
                            <ClueStatus ref="ClueLeaderStatus" v-model="filterModel.leader_status" @change="leaderStatusHandleChange" key="2"></ClueStatus>
                        </el-form-item>
                    </span>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                        <a class="searchCollapse" @click="collapse()">{{ searchTitle }}<i
                                :class="{ 'el-icon-fa-angle-down': isDown, 'el-icon-fa-angle-up': isUp }"></i></a>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row class="addBtn">
                <el-button type="primary" size="small"
                           @click="handleBatchSalers('绑定业务员',{ name: 'bind', args: clueIds })"> 批量分配
                </el-button>
                <el-button type="primary" size="small" :disabled="multipleSelection.length == 0" @click="batchBind">
                    批量绑定
                </el-button>
                <!-- <el-button type="primary" size="small"
                           @click="handleBatchSalers('转交业务员',{ name: 'transfer', args: clueIds })"> 批量转交
                </el-button> -->
                <el-button type="primary" size="small"  v-if="Acs('/sales-leads/query-repeat')" @click="showQueryRepeat = true">数据查重</el-button>
                <el-button v-if="Acs('/sales-leads/delete')" type="primary" size="small" @click="handleBatchDelete(clueIds)">批量删除</el-button>
                <el-button type="primary" size="small" @click="addClue()">+ 新增线索</el-button>
                <el-button v-if="Acs('/sales-leads/import')" type="success" size="small" @click="dialogImportVisible = true" :loading="importLoading">+导入线索</el-button>
                <ExportFile 
                v-if="Acs('/sales-leads/export')"
                url="/api/sales-leads/export" 
                :params="filterModel" 
                filename="线索数据表" 
                buttonName="线索导出"
                buttonType="success" >
                </ExportFile>
            </el-row>
            <el-table size="mini" style="width:100%" class="tabTopBorder" v-loading="loading"
                      @selection-change="handleSelectionChange" :data="cluesList">
                <el-table-column prop="id" type="selection"></el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="contact_name" label="申请人"></el-table-column>
                <el-table-column prop="mobile" label="申请人电话" width="160">
                    <template slot-scope="scope">
                        <span>{{scope.row.mobile}}</span>
                        <el-button v-if="scope.row.mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(scope.row)">解密</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="所在单位">
                    <template slot-scope="scope">
                        {{scope.row.customer_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="customer_type_name" label="单位类型"></el-table-column>
                <el-table-column prop="district_names" label="所在地区"></el-table-column>
                <el-table-column label="申请时间">
                    <template slot-scope="scope">
                        <time>{{ scope.row.created_at | date }}</time>
                    </template>
                </el-table-column>
                <el-table-column label="申请产品">
                    <template slot-scope="scope">
                        <div v-for="product in scope.row.products" :key="product.product_id">
                            <div v-if="scope.row.products.length == 1">
                                <el-tag>{{ product.product_name }}</el-tag>
                            </div>
                        </div>
                        <div v-if="scope.row.products.length > 1">
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content" v-for="product in scope.row.products" :key="product.product_id"
                                     class="line-gap">{{product.product_name}}
                                </div>
                                <el-tag>{{ scope.row.products[0].product_name }}...</el-tag>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="业务员">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.user_id == 0 && scope.row.is_deleted == 0" type="primary" plain size="small"
                                   @click="handleSalers('分配线索给业务员',{ name: 'bind', args: clueIds }, scope.row )"> 分配
                        </el-button>
                        <div v-else>
                            <span>{{scope.row.username}}</span>
                            <i class="el-icon-fa-arrow-right" v-if="scope.row.is_deleted == 0" style="color: #F56C6C; cursor: pointer;margin-left:5px;"
                               title="转移给其他业务员"
                               @click="handleSalers('转交业务员', { name: 'transfer', args: clueIds }, scope.row )"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="status_str" label="申请人真实性"></el-table-column>
                <el-table-column prop="leader_status_str" label="负责人真实性"></el-table-column>
                <el-table-column prop="source_name" label="来源"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                        <el-button type="text" v-if="scope.row.is_deleted == 0" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="Acs('/sales-leads/delete') && scope.row.is_deleted == 0" @click="handleDelete(clueIds,scope.row)">删除</el-button>
                        <el-button v-if="scope.row.customer_id == 0 && scope.row.is_deleted == 0" type="primary" size="mini" @click="handleContact(scope.row)"
                                   style="margin-top:10px;">关联客户
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
        <assign-clue-dialog
                v-if="showAssign"
                :text="title"
                :actionYes="action_callback"
                @changeShow="changeShow1">
        </assign-clue-dialog>

        <!-- 关联客户 -->
        <contact-customer-dialog v-if="clueRow"
                :showDialog="showContact"
                :clue="clueRow"
                @changeShow="changeShow2"
                @saveCallback="saveCallback"
                :key="contact_customer_dialog_key">
        </contact-customer-dialog>

        <!-- 线索查重 -->
        <query-repeat v-if="showQueryRepeat" :display="showQueryRepeat" @watchQueryRepeatClose="watchQueryRepeatClose"></query-repeat>

        <!-- 导入线索 -->
        <el-dialog title="导入线索" :visible.sync="dialogImportVisible" @close="resetDialog" width="30%" center>
            <input type="file" ref="fileInput" @change="handleFileChange" style="display: none"/>
            <div>
                <el-input v-model="filePath" size="small" style="width: 60%;margin-right: 30px;" readonly></el-input>
                <el-button type="primary" @click="chooseFile" size="small">选择文件.xlsx</el-button>
            </div>
            <a href="/file/excel/线索模板.xlsx?v=20260805" style="color:blue;">线索模板下载.xlsx</a>
            <br><br>
            <p style="color:red;">提示：一次最多导入2000条线索</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogImportVisible = false">取消</el-button>
                <el-button type="primary" @click="importFile" :disabled="importDisabled">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="系统提示" :visible.sync="dialogImportError" @close="resetErrorDialog" width="80%" center>
            <el-row type="flex" class="row-bg" justify="center">
                <el-col :span="8"><div class="grid-content">警告，检测到以下行数存在异常，请处理后重新导入</div></el-col>
            </el-row>
            <el-table size="mini" style="width:100%" :data="err_data" max-height="500">
                <el-table-column prop="line_num" label="行数" width="80"></el-table-column>
                <el-table-column prop="error_str" label="异常原因" show-overflow-tooltip></el-table-column>
                <el-table-column prop="contact_name" label="申请人"></el-table-column>
                <el-table-column prop="mobile" label="申请人手机"></el-table-column>
                <el-table-column prop="qq" label="申请人QQ"></el-table-column>
                <el-table-column prop="customer_name" label="所在单位" width="150"></el-table-column>
                <el-table-column prop="customer_type_str" label="单位类型"></el-table-column>
                <el-table-column prop="district_str" label="所在地区" width="150"></el-table-column>
                <el-table-column prop="product_name" label="意向产品"></el-table-column>
                <el-table-column prop="source_str" label="线索来源"></el-table-column>
                <el-table-column prop="user_name" label="绑定业务员"></el-table-column>
                <el-table-column prop="memo" label="备注" show-overflow-tooltip></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogImportError = false">取消</el-button>
                <el-button type="primary" @click="saveErrData" :loading="saveErrDataLoading">导出异常数据</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<style scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 30px;
    color: #D9001B;
  }
  .row-bg {
    padding: 7px 0;
    background: rgba(254, 240, 240, 1);
  }
</style>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import ClueService from "~/services/SaleClues";
    import ProductService from "~/services/product";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import AssignClueDialog from "~/views/clue/dialog/assignClueDialog.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import ContactClueSelect from "~/widgets/ClueContactSelect.vue"
    import AdressClueSelect from "~/widgets/ClueAdressSelect.vue"
    import ContactCustomerDialog from "~/views/clue/dialog/contactCustomerDialog.vue";
    import QueryRepeat from "~/views/clue/dialog/QueryRepeat.vue";
    import ChannelCascader from "~/widgets/ChannelCascader.vue";
    import ClueStatus from "~/widgets/ClueStatus.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    import XLSX from 'xlsx';
    import ContactService from "~/services/contact";

    import moment from 'moment'
    import 'moment/locale/zh-cn'

    moment.locale('zh-cn')

    export default {
        data() {
            return {
                products: [],
                filterModel: {},
                userName: "",      //业务员姓名
                userList: [],      //用户列表
                loading: false,
                cluesList: [],     //销售线索列表
                productList: [],     //产品列表
                linkPage: null,       //分页信息
                clueIds: [],          //线索id容器，批量删除、绑定、转交用
                myClueId: "",         //当前线索id
                clueRow: null, // 当前选中的线索
                showAssign: false,
                showContact: false,
                multipleSelection: [],   //选中线索数组
                title: "",

                isCollapse: false,
                searchTitle: '展开',
                isDown: true,
                isUp: false,

                showQueryRepeat: false, // 显示查重窗口
                dialogImportVisible: false,
                filePath: '',
                excelData: [],
                importLoading: false,
                importDisabled: true,
                channel: {
                    pid: 0,
                    id: 0,
                },
                activeName: '',
                active_list: [],
                active_count: {},
                err_data_loading: false,
                err_data: [],
                dialogImportError: false,
                saveErrDataLoading: false,
                contact_customer_dialog_key: 0,
            }
        },
        components: {
            DistrictLinkage,
            Pagination,
            AssignClueDialog,
            UserSelect,
            ContactClueSelect,
            AdressClueSelect,
            ContactCustomerDialog,
            QueryRepeat,
            ChannelCascader,
            ClueStatus,
            ExportFile
        },
        filters: {
            date(val) {
                return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.filterModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.getSaleClues(params);
        },
        created() {
            this.initActive();
            this.getProducts();
        },
        mounted() {
            this.resetForm();
        },
        methods: {
            initActive(){
                this.active_list = [];
                this.activeName = '';
                ClueService.getCustomerTypeMap().forEach((item) => {
                    if(this.Acs('/sales-leads/allocation-' + item.value)){
                        this.active_list.push(item);
                        if(!this.activeName){
                            this.activeName = item.value;
                        }
                    }
                });
            },

            handleClick(tab, event) {
                this.resetForm();
            },

            resetDialog() {
                this.dialogImportVisible = false;
                this.filePath = '';
                this.$refs.fileInput.value = '';
                this.excelData = [];
                this.importDisabled = false;
            },
            resetErrorDialog(){
                this.err_data = [];
            },
            chooseFile() {
                this.$refs.fileInput.click();
            },
            handleFileChange(event) {
                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        if(this.excelData.length > 0){
                            this.importDisabled = false;
                        }
                    };
                    reader.readAsArrayBuffer(file);
                    this.filePath = file.name;
                    
                }
            },
            importFile() {
                const list = this.excelData.filter(obj => Object.keys(obj).length > 0);
                if(!list || list.length < 1){
                    this.$message({
                        message: '导入数据表格不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if(list.length > 2001){
                    this.$message({
                        message: '数据量过大，单次最多2000条记录',
                        type: 'warning'
                    });
                    return false;
                }
                let params = {
                    import_data: list,
                };
                this.importLoading = true;
                // 全部线索
                ClueService.import(params).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '导入成功',
                            type: 'success'
                        });
                        this.submitSearch();
                    }else if(res.code == 4220){
                        this.$message({
                            message: '导入失败，数据不符请检查!',
                            type: 'warning'
                        });
                        this.err_data = res.data;
                        this.dialogImportError = true;
                    }
                    this.importDisabled = false;
                    this.importLoading = false;
                }).catch(err => {
                    this.importDisabled = false;
                    this.importLoading = false;
                    console.error(err);
                });
                this.resetDialog();
            },
            // 获取所有产品
            getProducts() {
                ProductService.getOptionList().then(res => {
                    if (res.code == 0) {
                        this.productList = res.data;
                    }
                });
            },
            // 获取销售线索列表
            getSaleClues(params = {}) {
                if(!this.activeName || this.activeName < 1){
                    this.$message({
                        message: '无相关列表权限，请先授权！',
                        type: 'error'
                    });
                    return;
                }
                if(this.$route.query['tab']){
                    params['tab'] = this.$route.query['tab']
                }
                this.loading = true;
                // 全部线索
                ClueService.getAllocation(params, this.activeName).then(res => {
                    if (res.code == 0) {
                        this.cluesList = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                }).then(this.getCustomerTypeCount)
            },

            // 获取线索分配-单位类型统计
            getCustomerTypeCount() {
                if(this.$route.query['tab']){
                    params['tab'] = this.$route.query['tab']
                }
                // 全部线索
                ClueService.getCustomerTypeCount({}).then(res => {
                    if (res.code == 0) {
                        this.active_count = res.data;
                    }
                })
            },

            // 选中发生改变时候触发该事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.clueIds = [];
                let clueId = 0;
                this.multipleSelection.forEach((item, index) => {
                    clueId = item.id
                    this.clueIds.push(clueId);
                });
            },
            // 查看、编辑、删除、绑定、转交销售线索操作
            handleView(clue) {
                let routeData = this.$router.resolve({
                    path: "/sales-leads/view",
                    query: { id: clue.id, referer: this.$route.path },
                });
                window.open(routeData.href, '_blank');
            },
            handleEdit(clue) {
                let routeData = this.$router.resolve({
                    path: "/sales-leads/update",
                    query: { id: clue.id, referer: this.$route.path },
                });
                window.open(routeData.href, '_blank');
            },
            // 关联客户
            handleContact(clue) {
                this.contact_customer_dialog_key ++;
                this.showContact = true;
                this.myClueId = clue.id.toString();
                this.clueRow = clue
            },
            saveCallback() {
                this.submitSearch();
            },
            action_callback() {
            },
            // 批量操作或者转交业务员
            handleBatchSalers(text, action) {
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        message: '请先选中要操作的项',
                        type: 'warning'
                    });
                    return;
                }
                var _this = this;
                this.showAssign = true;
                this.action_callback = function (uid) {
                    let params = {
                        leads_ids: action.args,
                        // user_id: action.uid
                        // user_id: _this.currentUserId
                        user_id: uid
                    }
                    if (action.name == 'bind') {          //绑定业务员
                        ClueService.salesmanBind(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "批量绑定成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        });
                    } else if (action.name == 'transfer') {    //转交业务员
                        ClueService.transferSalers(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "批量转交成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        })
                    }
                }
                this.title = text;
            },
            // 单个操作或者转交业务员
            handleSalers(text, action, clue) {
                let _this = this;
                if (clue.id) {
                    this.clueIds.push(clue.id);
                }
                this.showAssign = true;
                this.action_callback = function (uid) {
                    let params = {
                        leads_ids: action.args,
                        // user_id: action.uid
                        // user_id: _this.currentUserId
                        user_id: uid
                    }
                    if (action.name == 'bind') {          //绑定业务员
                        ClueService.salesmanBind(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "绑定成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        });
                    } else if (action.name == 'transfer') {    //转交业务员
                        ClueService.transferSalers(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "转交成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        })
                    }
                }
                this.title = text;
                this.clueIds = [];
            },
            //单个删除
            handleDelete(leads_ids, myclue) {
                let _this = this;
                if (myclue.id) {
                    leads_ids.push(myclue.id);
                }
                this.$confirm("此操作是删除操作, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    ClueService.deleteClues(leads_ids).then(res => {
                        if (res.code == 0) {
                            _this.cluesList = _this.cluesList.filter(clue => {
                                return clue.id != myclue.id;
                            });
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }
                        this.getCustomerTypeCount();
                    });
                }).catch(() => {
                });
                this.clueIds = [];
            },

            //批量删除
            handleBatchDelete(leads_ids) {
                let _this = this;
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        message: '请先选中要删除的项',
                        type: 'warning'
                    });
                    return;
                }
                this.$confirm("此操作是删除操作, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    ClueService.deleteClues(leads_ids).then(res => {
                        if (res.code == 0) {
                            _this.multipleSelection.forEach((item, index) => {
                                _this.cluesList = _this.cluesList.filter(clue => {
                                    return clue != item;
                                });
                            });
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                        }
                        this.getCustomerTypeCount();
                    });
                }).catch(() => {
                });
            },
            changeShow1(isShow) {
                this.showAssign = isShow;
            },
            changeShow2(isShow) {
                this.showContact = isShow;
            },
            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChange(value) {
                this.filterModel.province_id = parseInt(value[0]);
                this.filterModel.city_id = parseInt(value[1]);
                this.filterModel.district_id = parseInt(value[2]);
            },

            //线索业务员姓名远程搜索组件赋值
            UserHandleChange(object) {
                this.filterModel.salesman = object.value;
            },

            //线索联系人远程搜索组件赋值
            ContactClueHandleChange(name) {
                this.filterModel.contact_name = name;
            },

            //线索联系人所在单位远程搜索组件赋值
            AdressClueHandleChange(name) {
                this.filterModel.customer_name = name;
            },

            resetForm() {
                this.filterModel = {
                    id: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    product_id: '',
                    // start_time: '',
                    // end_time: '',
                    apply_time: [],
                    salesman: '',
                    contact_name: '',
                    customer_name: '',
                    mobile:'',
                    source: '',
                    assign_type: 0,
                    enableAuthQuery: 0,
                    customer_type: '',
                };
                this.$refs["DistrictLinkage"].reset();
                this.$refs["ContactClueSelect"].reset();
                this.$refs["AdressClueSelect"].reset();
                this.$refs["ChannelCascader"].reset();
                this.$refs["ClueStatus"].reset();
                this.$refs["ClueLeaderStatus"].reset();
                this.submitSearch();
            },

            //筛选查询
            submitSearch() {
                var params = _.clone(this.filterModel);
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.getSaleClues(params);
            },

            addClue() {
                this.$router.push({
                    path: "/sales-leads/create",
                    query: {
                        referer: this.$route.path,
                    }
                })
            },

            collapse() {
                this.isCollapse = !this.isCollapse;
                if (this.isCollapse) {
                    this.searchTitle = "收起";
                    this.isUp = true;
                    this.isDown = false;
                } else {
                    this.searchTitle = "展开";
                    this.isUp = false;
                    this.isDown = true;
                }
            },

            watchQueryRepeatClose() {
                this.showQueryRepeat = false;
            },

            unlockMobile(row) {
                ContactService.decodeMobile({id: row.id, type: 3}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.$message.success("解密成功！");
                        row.mobile = res.data.mobile;
                    }
                })
            },

            //运营渠道 Cascader 级联选择器,切换事件,表单model赋值
            channelHandleChange(value) {
                if(value && value.length > 0){
                    this.filterModel.source = value[value.length - 1].toString();
                    this.channel = {
                        pid: value.length == 2 ? value[0] : 0,
                        id: value[value.length - 1],
                    };
                }else{
                    this.filterModel.source = '';
                    this.channel =  _.clone(_.extend(this.filterModel, {
                        pid: '',
                        id: '',
                    }));
                }
            },
            batchBind() {
                this.$confirm("你确定要绑定选中的这些线索？", "温馨提示", {type: "warning"}).then(ok => {
                    let params = {
                        leads_ids: this.clueIds,
                        user_id: this.$store.getters.userId
                    };
                    ClueService.salesmanBind(params).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: "绑定成功",
                                type: "success"
                            });
                            this.submitSearch();
                        }
                    });

                    return true;
                }).catch(cancel => {
                    return false;
                });
            },
            saveErrData(){
                if(!this.err_data || this.err_data.length < 1){
                    this.$message({
                        message: "无异常数据导出",
                        type: "error"
                    });
                    return false;
                }
                this.saveErrDataLoading = true;
                // 创建一个工作簿
                const workbook = XLSX.utils.book_new();
                const sheetName = 'Sheet1';

                // 创建表头行
                const header = ['行数', '异常原因', '申请人', '申请人手机', '申请人QQ', '所在单位', '单位类型', '所在地区', '意向产品', '线索来源', '绑定业务员', '备注'];

                // 将表头行和 JSON 数据一起放入一个数组
                const data = [header].concat(this.err_data.map(item => [item.line_num, item.error_str, item.contact_name, item.mobile, item.qq, item.customer_name, item.customer_type_str, item.district_str, item.product_name, item.source_str, item.user_name, item.memo]));

                // 将数据数组转换为工作表
                const worksheet = XLSX.utils.aoa_to_sheet(data);

                // // 定义列宽
                // const columnWidths = [
                //     { wpx: 10 }, // 列1宽度
                //     { wpx: 30 }, // 列2宽度
                //     { wpx: 20 },
                //     { wpx: 15 },
                //     { wpx: 15 },
                //     { wpx: 20 },
                //     { wpx: 15 },
                //     { wpx: 20 },
                //     { wpx: 20 },
                //     { wpx: 20 },
                // ];

                // // 设置列宽
                // worksheet['!cols'] = columnWidths;

                // // 定义表头样式
                // const headerStyle = {
                //     font: { bold: true },
                //     alignment: { horizontal: 'center' },
                // };

                // // 设置样式
                // worksheet.A1.s = headerStyle; // A1 表示第一个单元格
                // worksheet.B1.s = headerStyle;
                // worksheet.C1.s = headerStyle;
                // worksheet.D1.s = headerStyle;
                // worksheet.E1.s = headerStyle;
                // worksheet.F1.s = headerStyle;
                // worksheet.G1.s = headerStyle;
                // worksheet.H1.s = headerStyle;
                // worksheet.I1.s = headerStyle;
                // worksheet.J1.s = headerStyle;

                // 将工作表添加到工作簿
                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

                // 将工作簿保存为Excel文件
                XLSX.writeFile(workbook, '异常数据表.xlsx');
                this.saveErrDataLoading = false;
            },

            statusHandleChange(value){
                if(value && value.length > 0){
                    this.filterModel.status = value[0];
                    this.filterModel.status_child = value.length > 1 ? value[1] : '';
                }else{
                    this.filterModel.status = '';
                    this.filterModel.status_child = '';
                }
            },
            leaderStatusHandleChange(value){
                if(value && value.length > 0){
                    this.filterModel.leader_status = value[0];
                    this.filterModel.leader_status_child = value.length > 1 ? value[1] : '';
                }else{
                    this.filterModel.leader_status = '';
                    this.filterModel.leader_status_child = '';
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/clue/allocation.vue